/* src/app/modules/employees/employees-tabs.component.css */
/*# sourceMappingURL=employees-tabs.component.css.map */
